export default "__VITE_ASSET__CvVTPP7K__"